import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-hotel_icon_diamond",
  "use": "icon-hotel_icon_diamond-usage",
  "viewBox": "0 0 1284 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1284 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-hotel_icon_diamond\"><path d=\"M1284.012539 344.757367l-621.462069 679.242633L0 344.757367 334.485266 0h617.610032L1284.012539 344.757367z\" fill=\"#F2a900\" p-id=\"10627\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol